export const dealsTranslations = {
  en: {
    title: 'Deals',
    description: 'Manage deals and create invoices',
    descriptionTitle: 'Description',
    addDeal: 'New Deal',
    search: 'Search deals...',
    noDeals: 'No deals found',
    backToDeal: 'Back to Deals',
    generateQuote: 'Generate Quote',
    previewHtml: 'Preview HTML',
    editDeal: 'Edit Deal',
    updateStatus: 'Update Status',
    sendForSignature: 'Send for Signature',
    services: 'Services',
    templateModal: {
      title: 'Select Template for Document',
      description: 'Choose a template to generate a PDF document and create a signature link.',
      noTemplates: 'No templates available. Create a template in Settings first.',
      cancel: 'Cancel',
      downloadPdf: 'Download PDF',
      generating: 'Generating...',
      wait: 'Please wait...',
    },
    statusBadge: {
      draft: 'Draft',
      sent: 'Sent',
      accepted: 'Accepted',
      rejected: 'Rejected'
    },
    details: {
      total: 'Total Amount',
      created: 'Created',
      assignedTo: 'Assigned To',
      unassigned: 'Unassigned',
      dealNumber: 'Deal Number'
    },
    pagination: {
      showing: 'Showing',
      to: 'to',
      of: 'of',
      deals: 'deals',
      previous: 'Previous',
      next: 'Next'
    },
    filters: {
      title: 'Filters',
      status: 'Status',
      clearAll: 'Clear all filters'
    },
    form: {
      title: 'Deal Details',
      client: {
        label: 'Client',
        placeholder: 'Select a client...'
      },
      dealTitle: {
        label: 'Deal Title',
        placeholder: 'Enter deal title',
        date: 'Quote Date'
      },
      dealNumber: 'Deal Number',
      description: {
        label: 'Description',
        placeholder: 'Write a detailed description of the deal...'
      },
      services: {
        title: 'Services',
        addService: 'Add Service',
        configureInstallments: 'Configure Installments'
      },
      ai: {
        aiAssistant: 'AI Assistant',
        generateWithAI: 'Generate text with AI',
        promptLabel: 'AI Prompt:',
        promptPlaceholder: 'What do you want the AI to do with this text?',
        promptRequired: 'Please enter a prompt to generate text',
        emptyResponseError: 'No text generated. Try again with a different prompt.',
        currentText: 'Current text:',
        serviceTitle: 'Service title:',
        noText: 'No text',
        promptExamples: 'Prompt examples:',
        promptExample1: 'Improve the existing text by better highlighting client benefits',
        promptExample2: 'Create a professional description with bold titles and bullet points for advantages',
        promptExample3: 'Rewrite the text more persuasively, organizing it into "What we offer", "Benefits" and "Why choose us"',
        promptExample4: 'Create a completely new description that emphasizes concrete results and benefits',
        cancel: 'Cancel',
        generating: 'Generating...',
        generate: 'Generate text'
      },
      status: {
        label: 'Status',
        options: {
          draft: 'Draft',
          sent: 'Sent',
          accepted: 'Accepted',
          rejected: 'Rejected'
        }
      },
      notifications: {
        label: 'Send WhatsApp Notifications',
        description: 'Enable automated WhatsApp notifications for this deal'
      },
      buttons: {
        create: 'Create Deal',
        update: 'Update Deal',
        cancel: 'Cancel'
      }
    },
    contract: {
      upload: 'Upload Signed Contract',
      uploadDescription: 'Upload a signed PDF contract to mark this deal as accepted.',
      selectFile: 'Click to select a PDF file',
      dragDrop: 'or drag and drop here',
      onlyPdf: 'Only PDF files are accepted',
      remove: 'Remove',
      uploadAndAccept: 'Upload and Accept Deal',
      uploading: 'Uploading...'
    },
    whatsapp: {
      verifyTitle: 'Verify with WhatsApp',
      verifyDescription: 'Verify this deal using WhatsApp to complete the signature process.',
      phoneNumber: 'WhatsApp Number',
      verificationCode: 'Verification Code',
      sendCode: 'Send Verification Code',
      enterCode: 'Enter 6-digit code',
      sending: 'Sending...',
      verifying: 'Verifying...',
      verifyComplete: 'Verify & Complete'
    },
    signature: {
      information: 'Signature Information',
      signedDate: 'Signed Date',
      acceptanceDate: 'Acceptance Date',
      notSigned: 'Not signed yet',
      editDate: 'Edit Date',
      enterDate: 'Enter signature date (YYYY-MM-DD):',
      dateUpdated: 'Signature date updated',
      invalidDate: 'Invalid date format. Please use YYYY-MM-DD',
      verifiedViaWhatsApp: 'Verified via WhatsApp',
      link: 'Signature Link',
      generateLink: 'Generate Signature Link',
      linkCopied: 'Link copied!',
      copyLink: 'Copy Signature Link',
      viewSignaturePage: 'View Signature Page',
      processing: 'Processing...',
      generationSuccess: 'Signature link generated successfully',
      generationError: 'Failed to generate signature link',
      shareTitle: 'Share Signature Link',
      shareDescription: 'Share the signature link with your client using one of the following methods:',
      shareVia: 'Share via:',
      shareNow: 'Share Now',
      whatsappMessage: 'Please sign the document at the following link:',
      emailSubject: 'Document for signature',
      emailMessage: 'Please sign the document at the following link:'
    },
    statusUpdate: {
      title: 'Update Deal Status',
      currentStatus: 'Current Status',
      newStatus: 'New Status',
      note: 'Add Note',
      notePlaceholder: 'Enter a note explaining the status change...',
      update: 'Update Status',
      cancel: 'Cancel',
      success: 'Deal status updated successfully',
      error: 'Failed to update deal status',
      history: 'Note History',
      noNotes: 'No notes yet',
      statusChangedFrom: 'Status changed from',
      statusChangedTo: 'to',
      editActivity: 'Edit activity',
      completeActivity: 'Complete activity',
      deleteActivity: 'Delete activity',
      addNote: 'Add note',
      addTask: 'Add activity',
      task: 'Activity',
      deleteNote: 'Delete note',
      editNote: 'Edit note'
    },
    emailTimeline: {
      summaryTitle: 'Email summary',
      generating: 'Generating summary…',
      regenerate: 'Update summary',
      newEmails: '{count} new emails',
      updatedAt: 'Updated',
      lastInteraction: 'Last email',
      threadsCount: '{threads} conversations · {messages} messages',
      messages: 'messages',
      mailboxOf: 'Mailbox of',
      openInGmail: 'Open in Gmail',
      openInOutlook: 'Open in Outlook',
      loadMore: 'Load more emails',
      loadError: 'Unable to load emails',
      noSubject: '(no subject)'
    },
    activities: {
      addTask: 'Add Task',
      addActivity: 'Add Activity',
      title: 'Title',
      activityTitle: 'Activity title',
      type: 'Type',
      status: 'Status',
      date: 'Date',
      time: 'Time',
      description: 'Description',
      descriptionPlaceholder: 'Enter details about this activity',
      saving: 'Saving...',
      saveActivity: 'Save Activity',
      call: 'Call',
      meeting: 'Meeting',
      email: 'Email',
      task: 'Task',
      note: 'Note',
      other: 'Other',
      pending: 'Pending',
      completed: 'Completed',
      overdue: 'Overdue'
    }
  },
  it: {
    title: 'Offerte',
    description: 'Gestisci offerte e crea fatture',
    descriptionTitle: 'Descrizione',
    addDeal: 'Nuova Offerta',
    search: 'Cerca offerte...',
    noDeals: 'Nessuna offerta trovata',
    backToDeal: 'Torna alle Offerte',
    generateQuote: 'Genera Preventivo',
    previewHtml: 'Anteprima HTML',
    editDeal: 'Modifica Offerta',
    updateStatus: 'Aggiorna Stato',
    sendForSignature: 'Invia per Firma',
    services: 'Servizi',
    templateModal: {
      title: 'Seleziona Template per il Documento',
      description: 'Scegli un template per generare un documento PDF e creare un link di firma.',
      noTemplates: 'Nessun template disponibile. Crea prima un template nelle Impostazioni.',
      cancel: 'Annulla',
      downloadPdf: 'Scarica PDF',
      generating: 'Generazione in corso...',
      wait: 'Attendere prego...',
    },
    statusBadge: {
      draft: 'Bozza',
      sent: 'Inviata',
      accepted: 'Accettata',
      rejected: 'Rifiutata'
    },
    details: {
      total: 'Importo Totale',
      created: 'Creata il',
      assignedTo: 'Assegnata a',
      unassigned: 'Non assegnata',
      dealNumber: 'Numero Deal'
    },
    pagination: {
      showing: 'Visualizzazione',
      to: 'a',
      of: 'di',
      deals: 'offerte',
      previous: 'Precedente',
      next: 'Successivo'
    },
    filters: {
      title: 'Filtri',
      status: 'Stato',
      clearAll: 'Cancella tutti i filtri'
    },
    form: {
      title: 'Dettagli Offerta',
      client: {
        label: 'Cliente',
        placeholder: 'Seleziona un cliente...'
      },
      dealTitle: {
        label: 'Titolo Offerta',
        placeholder: 'Inserisci titolo offerta',
        date: 'Data Offerta'
      },
      dealNumber: 'Numero Deal',
      description: {
        label: 'Descrizione',
        placeholder: 'Scrivi una descrizione dettagliata dell\'offerta...'
      },
      services: {
        title: 'Servizi',
        addService: 'Aggiungi Servizio',
        configureInstallments: 'Configura Rate'
      },
      ai: {
        aiAssistant: 'Assistente AI',
        generateWithAI: 'Genera testo con AI',
        promptLabel: 'Prompt per l\'AI:',
        promptPlaceholder: 'Cosa vuoi che l\'AI faccia con questo testo?',
        promptRequired: 'Inserisci un prompt per generare il testo',
        emptyResponseError: 'Nessun testo generato. Riprova con un prompt diverso.',
        currentText: 'Testo attuale:',
        serviceTitle: 'Titolo del servizio:',
        noText: 'Nessun testo',
        promptExamples: 'Esempi di prompt:',
        promptExample1: 'Migliora il testo esistente evidenziando meglio i benefici per il cliente',
        promptExample2: 'Crea una descrizione professionale con titoli in grassetto e punti elenco per i vantaggi',
        promptExample3: 'Riformula il testo in modo più persuasivo, organizzandolo in "Cosa offriamo", "Vantaggi" e "Perché sceglierci"',
        promptExample4: 'Crea una descrizione completamente nuova che enfatizza risultati e benefici concreti',
        cancel: 'Annulla',
        generating: 'Generazione in corso...',
        generate: 'Genera testo'
      },
      status: {
        label: 'Stato',
        options: {
          draft: 'Bozza',
          sent: 'Inviata',
          accepted: 'Accettata',
          rejected: 'Rifiutata'
        }
      },
      notifications: {
        label: 'Invia Notifiche WhatsApp',
        description: 'Abilita notifiche WhatsApp automatiche per questa offerta'
      },
      buttons: {
        create: 'Crea Offerta',
        update: 'Aggiorna offerta',
        cancel: 'Annulla'
      }
    },
    contract: {
      upload: 'Carica Contratto Firmato',
      uploadDescription: 'Carica un contratto PDF firmato per contrassegnare questa offerta come accettata.',
      selectFile: 'Clicca per selezionare un file PDF',
      dragDrop: 'o trascina qui',
      onlyPdf: 'Sono accettati solo file PDF',
      remove: 'Rimuovi',
      uploadAndAccept: 'Carica e Accetta Offerta',
      uploading: 'Caricamento...'
    },
    whatsapp: {
      verifyTitle: 'Verifica con WhatsApp',
      verifyDescription: 'Verifica questa offerta usando WhatsApp per completare il processo di firma.',
      phoneNumber: 'Numero WhatsApp',
      verificationCode: 'Codice di Verifica',
      sendCode: 'Invia Codice di Verifica',
      enterCode: 'Inserisci codice a 6 cifre',
      sending: 'Invio in corso...',
      verifying: 'Verifica in corso...',
      verifyComplete: 'Verifica e Completa'
    },
    signature: {
      information: 'Informazioni Firma',
      signedDate: 'Data Firma',
      acceptanceDate: 'Data Accettazione',
      notSigned: 'Non ancora firmato',
      editDate: 'Modifica Data',
      enterDate: 'Inserisci data firma (AAAA-MM-GG):',
      dateUpdated: 'Data firma aggiornata',
      invalidDate: 'Formato data non valido. Usa AAAA-MM-GG',
      verifiedViaWhatsApp: 'Verificato via WhatsApp',
      link: 'Link di Firma',
      generateLink: 'Genera Link di Firma', 
      linkCopied: 'Link copiato!',
      copyLink: 'Copia Link di Firma',
      viewSignaturePage: 'Visualizza Pagina di Firma',
      processing: 'Elaborazione...',
      generationSuccess: 'Link di firma generato con successo',
      generationError: 'Impossibile generare il link di firma',
      shareTitle: 'Condividi Link di Firma',
      shareDescription: 'Condividi il link di firma con il tuo cliente utilizzando uno dei seguenti metodi:',
      shareVia: 'Condividi tramite:',
      shareNow: 'Condividi Ora',
      whatsappMessage: 'Per favore firma il documento al seguente link:',
      emailSubject: 'Documento da firmare',
      emailMessage: 'Per favore firma il documento al seguente link:'
    },
    statusUpdate: {
      title: 'Aggiorna Stato Offerta',
      currentStatus: 'Stato Attuale',
      newStatus: 'Nuovo Stato',
      note: 'Nota',
      notePlaceholder: 'Inserisci una nota per spiegare il cambio di stato...',
      update: 'Aggiorna stato',
      cancel: 'Annulla',
      success: 'Stato dell\'offerta aggiornato con successo',
      error: 'Impossibile aggiornare lo stato dell\'offerta',
      history: 'Cronologia note',
      noNotes: 'Nessuna nota disponibile',
      statusChangedFrom: 'Stato cambiato da',
      statusChangedTo: 'a',
      editActivity: 'Modifica attività',
      completeActivity: 'Completa attività',
      deleteActivity: 'Elimina attività',
      addNote: 'Aggiungi nota',
      addTask: 'Aggiungi attività',
      task: 'Attività',
      deleteNote: 'Elimina nota',
      editNote: 'Modifica nota'
    },
    emailTimeline: {
      summaryTitle: 'Riassunto email',
      generating: 'Generazione riassunto…',
      regenerate: 'Aggiorna riassunto',
      newEmails: '{count} nuove email',
      updatedAt: 'Aggiornato',
      lastInteraction: 'Ultima email',
      threadsCount: '{threads} conversazioni · {messages} messaggi',
      messages: 'messaggi',
      mailboxOf: 'Casella di',
      openInGmail: 'Apri in Gmail',
      openInOutlook: 'Apri in Outlook',
      loadMore: 'Carica altre email',
      loadError: 'Impossibile caricare le email',
      noSubject: '(nessun oggetto)'
    },
    activities: {
      addTask: 'Aggiungi Attività',
      addActivity: 'Aggiungi Attività',
      title: 'Titolo',
      activityTitle: 'Titolo attività',
      type: 'Tipo',
      status: 'Stato',
      date: 'Data',
      time: 'Ora',
      description: 'Descrizione',
      descriptionPlaceholder: 'Inserisci dettagli su questa attività',
      saving: 'Salvataggio...',
      saveActivity: 'Salva Attività',
      call: 'Chiamata',
      meeting: 'Riunione',
      email: 'Email',
      task: 'Attività',
      note: 'Nota',
      other: 'Altro',
      pending: 'In attesa',
      completed: 'Completata',
      overdue: 'In ritardo'
    }
  }
};